import Vue from 'vue'
import Vuex from 'vuex'
import form from '@/store/form'
import company from '@/store/company'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    form,
    company
  },
  plugins: [createPersistedState()]
})
